import {UI} from "../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../Messages";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../common/MerchantButton";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {PoweredByBlink} from "../../PoweredByBlink";
import {MISSING_INFO} from "../../../Constants";
import {DonationStore} from "../../../State";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {MessageElement} from "../../../widget/ui/MessageElement";


class RecurringDonorStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.DONATE_PAGE_CARD_TITLE;

    @styleRule
    center = {
        margin: "10px 0 20px",
        textAlign: "center",
    };

    @styleRule
    link = this.themeProps.DONATE_PAGE_LINK;

    @styleRule
    text = {
        marginBottom: 16,
        color: this.themeProps.DONATE_PAGE_TEXT_COLOR,
    };

    @styleRule
    button = {
        ...this.themeProps.DONATE_PAGE_BUTTON,
        marginTop: 4,
        marginBottom: 10,
    };
}

@registerStyle(RecurringDonorStyle)
export class RecurringDonorPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const publicationName = iFrameMerchantService.getMerchant().name;
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        return [
            <div className={styleSheet.title}>{Messages.donatePageRecurringDonorTitle}</div>,
            <MessageElement className={styleSheet.text} message={Messages.activeDonationDescription2(publicationName)} />,
            <MessageElement className={styleSheet.text} message={Messages.donatePageRecurringDonorInfo(donation.formatPrice())} />,
            <MessageElement className={styleSheet.text} message={Messages.donatePageRecurringDonorNextPayment(
                donation.getNextBillingDate()?.format("MMM DD, YYYY") || MISSING_INFO,
                donation.getPaymentMethod()?.getLastDigits() || MISSING_INFO)}/>,
            <MerchantButton onClick={() => this.options.changeURL(DONATE_PAGE_URLS.donate)}
                            className={styleSheet.button}>
                {Messages.makeAnotherDonation}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.editRecurringDonation} onClick={() => this.options.changeURL(DONATE_PAGE_URLS.editDonation)}
                      className={styleSheet.link}/>
            </div>,
            <PoweredByBlink />,
        ];
    }

    onMount() {
        super.onMount();
        this.attachChangeListener(DonationStore, () => {
            if (!iFrameUserDataService.getActiveRecurringDonation()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate);
            }
        })
    }
}
